import React from 'react';
import { AppFormLayout, AppForm, AppFormPageProps, AppFormItemEnum } from 'qcc'
import api, { PosMerchant } from "api";

export default class EditForm extends React.PureComponent<AppFormPageProps> {
  state = {}
  render() {
    let { formData, mode, id,extraData } = this.props;
    let {bankOptions} =extraData;
    console.log('bankOptions:',bankOptions)
    return (<AppFormLayout defaultButton mode={this.props.mode}>
      <AppFormLayout.Form>
        <AppForm entity='pos_merchant' loadingData={false} mode={mode}
          keyValue={formData.id}
          formData={formData}
          afterSave={() => { this.props.afterSave && this.props.afterSave() }}>
          <AppForm.Section labelWidth={140}>
            <AppForm.Item keyName='project_id' field='project_id' itemType={AppFormItemEnum.hidden} />
            <AppForm.Item labelHidden render={() => {
              return <div style={{ color: '#005AB5' }}>请根据收款机构提供的POS商户信息进行填写并确保正确</div>
            }} />
            <AppForm.Item label='收单机构'
              keyName='business_name'
              field='business_name'
              itemType={AppFormItemEnum.input} req />

            <AppForm.Item label='POS商户名称'
              keyName='merchant_name'
              placeholder="请输入POS商户名称"
              unRepeat
              scopeField="project_id"
              field='merchant_name'
              itemType={AppFormItemEnum.input} req />


            <AppForm.Item label='POS商户号(银行卡)'
              keyName='merchant_code'
              placeholder="请输入POS商户号(银行卡)"
              unRepeat
              scopeField="project_id"
              field='merchant_code'
              itemType={AppFormItemEnum.input} req />

            <AppForm.Item label='POS商户号(扫码)'
              keyName='merchant_code_scan'
              placeholder="请输入POS商户号(扫码)"
              unRepeat
              scopeField="project_id"
              field='merchant_code_scan'
              itemType={AppFormItemEnum.input} req />

            <AppForm.Item label='入账银行'
              keyName='erp_bank_id'
              placeholder="选择入账银行"
              field='erp_bank_id'
              options = {bankOptions}
              itemType={AppFormItemEnum.select}  />


          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
    </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/pos/merchant/EditForm.tsx